import { SharedService } from './../shared.service';
import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { AcademicPartner } from 'src/app/core/models/AcademicPartner';
import { UIControlTyp } from 'src/app/core/models/UIControlTyp';

@Component({
  standalone: false,
  selector: 'fdb-academic-partners',
  templateUrl: './academic-partners.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./academic-partners.component.scss']
})
export class AcademicPartnersComponent implements OnInit {
  public UIControlTyp = UIControlTyp;
  public SelectedAcademicPartnerIds: number[] = [];
  /** Hiermit können Sie den UIControlTyp entscheiden => Default DropDownList */
  @Input() uiController: UIControlTyp = UIControlTyp.DropDownList;
  // tslint:disable-next-line: no-input-rename
  @Input('values')
  get values() {
    const val = this.uiController === UIControlTyp.MultiSelectList ?
      this.SelectedAcademicPartnerIds :
      Number(this.AcademicPartner ? this.AcademicPartner.id : 0);
    return val;
  }
  set values(val: number | (string | number)[]) {
    if (Array.isArray(val)) {
      this.SelectedAcademicPartnerIds = this.normalizeIds(val);
      this.getRefreshSelectedValue();
      this.refreshAcademicPartnerList();
    } else {
      this.AcademicPartner = this.getObjectFromList(val as number);
    }
  }
  @Output() valuesChange = new EventEmitter();

  /** Enthält die ausgewählten Wert bei UIControlTyp.DropDownList */
  public AcademicPartner: AcademicPartner;
  /** Enthält die ausgewählten Werte bei UIControlTyp.MultiSelectList */
  public AcademicPartners: AcademicPartner[] = [];
  /** Enthält die Werte die angezeigt werden dürfen */
  public AcademicPartnerList: AcademicPartner[] = [];
  /** Enthält die Originalliste mit allen Werten */
  private OriginalValues: AcademicPartner[] = [];

  constructor(private modulService: SharedService, private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.initAcademicPartners();
  }

  initAcademicPartners() {
    this.modulService.getAcademicPartners(true)
      .subscribe(apiResult => {
        if (!apiResult.isSuccessful) {
          this.modulService.showNotification(apiResult.message, 'error');
        }
        if (apiResult.payload) {
          this.OriginalValues = apiResult.payload;
          this.refreshAcademicPartnerList();
          this.getRefreshSelectedValue();
          this.rebindSelectedAcademicPartnerIds();
          this.cdRef.detectChanges();
        }
      },
        err => this.modulService.showNotification(err, 'error'));
  }

  filterAcademicPartnerList(value: string) {
    this.refreshAcademicPartnerList(value);
  }

  valueChanged(event?: (string | number)[]): void {
    if (this.uiController === UIControlTyp.MultiSelectList) {
      this.SelectedAcademicPartnerIds = this.normalizeIds(event || this.SelectedAcademicPartnerIds);
      this.getRefreshSelectedValue();
      this.refreshAcademicPartnerList();
    }
    this.valuesChange.emit(this.values);
  }

  getObjectFromList(id: string | number): AcademicPartner {
    if (id === 0 || id === "") {
      return new AcademicPartner().getEmptyModel();
    }
    id = Number(id);
    if (isNaN(id)) {
      return new AcademicPartner().getEmptyModel();
    }

    const find = this.OriginalValues.find(unit => Number(unit.id) === id);
    return find ? find : new AcademicPartner().setId(id);
  }
  getName() {
    const find = this.getObjectFromList(Number(this.AcademicPartner ? this.AcademicPartner.id : 0));
    if (find) {
      return find.id === 0 ? '-- Bitte pflegen --' : find.name;
    }
    return '';
  }
  getRefreshSelectedValue() {
    this.AcademicPartners = this.SelectedAcademicPartnerIds
      .map(id => this.OriginalValues.find(y => Number(y.id) === Number(id)) || new AcademicPartner().setId(id));
  }

  private rebindSelectedAcademicPartnerIds() {
    this.SelectedAcademicPartnerIds = [...this.SelectedAcademicPartnerIds];
    setTimeout(() => {
      this.SelectedAcademicPartnerIds = [...this.SelectedAcademicPartnerIds];
    });
  }

  private normalizeIds(values: (string | number)[]): number[] {
    return values
      .map(x => Number(x))
      .filter(x => !isNaN(x) && x > 0);
  }

  private refreshAcademicPartnerList(filterValue: string = '') {
    const filter = filterValue.toLowerCase();
    const activeValues = this.OriginalValues
      .filter(s => s.isActive === true)
      .filter(s => filter === '' || (s.name || '').toLowerCase().indexOf(filter) !== -1);
    const selectedValues = this.SelectedAcademicPartnerIds
      .map(id => this.OriginalValues.find(x => Number(x.id) === Number(id)))
      .filter(x => !!x);
    this.AcademicPartnerList = this.mergeById(activeValues, selectedValues as AcademicPartner[]);

    if (this.uiController === UIControlTyp.DropDownList) {
      this.AcademicPartnerList.unshift(new AcademicPartner().getEmptyModel());
    }
  }

  private mergeById(first: AcademicPartner[], second: AcademicPartner[]): AcademicPartner[] {
    const map: { [key: number]: AcademicPartner } = {};
    first.forEach(x => map[Number(x.id)] = x);
    second.forEach(x => map[Number(x.id)] = x);
    return Object.keys(map).map(key => map[Number(key)]);
  }
}
